<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  font-family: '微软雅黑', Arial, sans-serif;
  min-width: 1200px;
}
</style>